import store from './store';
import router from './router';
import VueCookies from 'vue-cookies';
import config from '@/utils/config.js';
/*路由守卫*/
router.beforeEach((to, from, next) => {
    const user = 1;
    // console.log(to)
    console.log(from)
    if(from.meta && from.meta.record){ 
        VueCookies.set('routerFrom',{
            path:from.path,
            name:from.meta.name,
        })
    } else{
        VueCookies.remove('routerFrom')  
    }
    console.log('token', store.getters.token)
    //有token
    if (store.getters.token && store.getters.token != 'null') {
        if (to.path === '/login') {
            next({
                path: '/'
            });
        } else if(store.getters.userInfo && store.getters.userInfo.id) {
            if(to.meta.role && to.meta.role.length){
                const role = to.meta.role[0];
                const type = store.getters.userInfo.type;
                if(type == user && role == 'user' || type != user && role == 'company'){
                    next();
                } else if( type == user && role == 'company'){
                    next('/user');
                } else if( type != user && role == 'user'){
                    next('/company');
                }
            } else{
                 next();
            }
        } else{
            //第一次加载页面获取用户数据
            store.dispatch('getUserInfo').then(res=>{
                if(to.meta.role && to.meta.role.length){
                    const role = to.meta.role[0];
                    const type = res.type;
                    if(type == user && role == 'user' || type != user && role == 'company'){
                        next();
                    } else if( type == user && role == 'company'){
                        next('/user');
                    } else if( type != user && role == 'user'){
                        next('/company');
                    }
                } else{
                     next();
                }
            }).catch(err=>{
                VueCookies.remove('token');  
                next({
                    path: '/index'
                });
            })
        }
    } else {
        //没有token
        if (
            ~to.path.indexOf('/user/') ||
            ~to.path.indexOf('/company/') ||
            ~to.path.indexOf('/video') ||
            ~to.path.indexOf('/review_info') ||
            ~to.path.indexOf('/exam_info')
        ) {
            //用户模块需要登录
            next('/login');
        } else {
            next();
        }
    }
})
router.afterEach((to, from, next) => {
    document.title = config.baseTitle+ '-' + to.meta.name; //标题
    window.scrollTo(0, 0); //跳回顶部
});